export const translations = {
  en: {
    dir: 'ltr',
    label: 'English',
    nav: {
      about: 'About',
      facilities: 'Facilities',
      spaces: 'Spaces',
      gallery: 'Gallery',
      testimonials: 'Testimonials',
      location: 'Location',
      contact: 'Contact',
      admin: 'Admin',
      adminPortal: 'Admin Portal',
    },
    hero: {
      location: 'Seer Hamdan \u00B7 Anantnag \u00B7 J&K',
      title1: 'Khan Complex',
      title2: 'Seer Hamdan',
      subtitle: 'A Premium Mixed-Use Commercial Hub \u2014 offering retail shops, modern offices, and versatile commercial spaces in the heart of Seer Hamdan.',
      explore: 'Explore Spaces',
      contactNow: 'Contact Now',
    },
    about: {
      label: 'About Us',
      title1: 'A Modern Commercial',
      title2: '& Retail Hub',
      desc1: 'Khan Complex is a premier mixed-use commercial development strategically located in Seer Hamdan, Anantnag, Jammu & Kashmir. Designed to serve as the central business hub for the region, the complex offers a diverse range of spaces including retail shops, professional offices, and a grand commercial hall.',
      desc2: 'Whether you\'re looking to establish a retail presence, set up a professional office, or host events in our expansive hall, Khan Complex provides the perfect environment for business growth and success.',
      highlight1: 'Strategic Location',
      highlight1Desc: 'Prime commercial area in Seer Hamdan, Anantnag',
      highlight2: 'Mixed-Use Complex',
      highlight2Desc: 'Retail shops, offices, and commercial halls',
      highlight3: 'High Footfall',
      highlight3Desc: 'Bustling area with steady customer traffic',
    },
    facilities: {
      label: 'What We Offer',
      title: 'World-Class Facilities',
      retailShops: 'Retail Shops',
      retailShopsDesc: 'Premium ground floor retail spaces perfect for shops and showrooms',
      officeSpaces: 'Office Spaces',
      officeSpacesDesc: 'Modern office rooms ideal for professional services and businesses',
      parking: 'Parking Facility',
      parkingDesc: 'Convenient parking area for tenants and visitors',
      powerBackup: 'Power Backup',
      powerBackupDesc: 'Uninterrupted power supply ensuring business continuity',
      primeLocation: 'Prime Location',
      primeLocationDesc: 'Strategically located in the commercial heart of Seer Hamdan',
      highFootfall: 'High Footfall Area',
      highFootfallDesc: 'Bustling commercial zone with consistent customer traffic',
    },
    listings: {
      label: 'Available Spaces',
      title: 'Find Your Perfect Space',
      all: 'All',
      enquireNow: 'Enquire Now',
      noSpaces: 'No spaces found',
      enquireTitle: 'Enquire About',
      yourName: 'Your Name',
      phone: 'Phone Number',
      message: 'Message (Optional)',
      submit: 'Submit Enquiry',
      submitting: 'Submitting...',
    },
    gallery: {
      label: 'Gallery',
      title: 'Visual Showcase',
    },
    testimonials: {
      label: 'What Our Tenants Say',
      title: 'Trusted by Businesses',
    },
    location: {
      label: 'Location',
      title: 'Find Us Here',
      address: 'Khan Complex',
      area: 'Seer Hamdan, Anantnag',
      state: 'Jammu & Kashmir, India',
      directions: 'Get Directions',
    },
    contact: {
      label: 'Get in Touch',
      title: 'Contact Us',
      desc: 'Interested in a space? Have questions about availability or pricing? Reach out to us and our team will get back to you promptly.',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      yourName: 'Your Name',
      phonePlaceholder: '+91 XXXXXXXXXX',
      messagePlaceholder: 'Tell us about your requirements...',
      namePlaceholder: 'Enter your full name',
      sendMessage: 'Send Message',
      sending: 'Sending...',
    },
    footer: {
      desc: 'A premium mixed-use commercial hub in Seer Hamdan, Anantnag, J&K.',
      quickLinks: 'Quick Links',
      contactInfo: 'Contact',
      copyright: '\u00A9 2026 Khan Complex Seer Hamdan. All rights reserved.',
    },
  },
};
